import { serializable, alias, primitive } from 'serializr';


export class ParentProductList {

    @serializable
    id?: number;

    @serializable
    name?: string;

    @serializable
    approved?: number;

    @serializable
    declined?: number;

    @serializable
    draft?: number;

    @serializable(alias('unique_id', primitive()))
    uniqueId?: string;

    @serializable(alias('in_review', primitive()))
    inReview?: number;

    @serializable
    total?: number;

}

export class ParentProductListQueryParams {

    @serializable(alias('sort_key', primitive()))
    sortBy?: string;

    @serializable(alias('sort_order', primitive()))
    sortDir?: string;

    @serializable
    page?: number;

    @serializable
    search?: number;

}
